'use strict';

/** @namespace */
module.exports = require('./src/js/lib');
